var _circle, _circle2, _path, _path2, _path3, _g, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 56.5,
    r: 5,
    stroke: "#202E5F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 102.5,
    r: 3,
    stroke: "#848A9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 109L135.256 113.744L140 115.5L135.256 117.256L133.5 122L131.744 117.256L127 115.5L131.744 113.744L133.5 109Z",
    fill: "#E3E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 12L36.2556 16.7444L41 18.5L36.2556 20.2556L34.5 25L32.7444 20.2556L28 18.5L32.7444 16.7444L34.5 12Z",
    fill: "#E3E4E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0707 46C64.5093 46 65.6726 47.0669 65.6726 48.3816V53.1931C67.9785 53.1518 70.5666 53.1518 73.4783 53.1518H87.355C90.2667 53.1518 92.8514 53.1518 95.1607 53.1931V48.3816C95.1607 47.0669 96.324 46 97.7626 46C99.2013 46 100.365 47.0669 100.365 48.3816V53.3996C105.355 53.7644 108.635 54.6661 111.044 56.8688C113.453 59.0749 114.434 62.076 114.833 66.65V70.0917H46V66.65C46.3992 62.076 47.3801 59.0783 49.7893 56.8688C52.1984 54.6661 55.4749 53.7644 60.4688 53.3996V48.3816C60.4688 47.0669 61.6355 46 63.0707 46Z",
    fill: "#202E5F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_3529_34437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.833 87.3V80.4167C114.833 77.5291 114.788 72.3804 114.743 70.0917H46.0199C45.9751 72.3804 46.0199 77.5291 46.0199 80.4167V87.3C46.0199 100.279 46.0199 106.769 50.0466 110.8C54.0837 114.833 60.5712 114.833 73.5463 114.833H87.313C100.288 114.833 106.772 114.833 110.806 110.8C114.833 106.769 114.833 100.279 114.833 87.3Z",
    fill: "#D4D5DD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4647 84.7188C81.1493 84.7188 81.8058 84.9907 82.2899 85.4748C82.774 85.9589 83.0459 86.6154 83.0459 87.3V91.6021H87.348C88.0326 91.6021 88.6892 91.874 89.1733 92.3581C89.6573 92.8422 89.9293 93.4987 89.9293 94.1833C89.9293 94.8679 89.6573 95.5245 89.1733 96.0085C88.6892 96.4926 88.0326 96.7646 87.348 96.7646H83.0459V101.067C83.0459 101.751 82.774 102.408 82.2899 102.892C81.8058 103.376 81.1493 103.648 80.4647 103.648C79.7801 103.648 79.1236 103.376 78.6395 102.892C78.1554 102.408 77.8835 101.751 77.8835 101.067V96.7646H73.5814C72.8968 96.7646 72.2402 96.4926 71.7562 96.0085C71.2721 95.5245 71.0001 94.8679 71.0001 94.1833C71.0001 93.4987 71.2721 92.8422 71.7562 92.3581C72.2402 91.874 72.8968 91.6021 73.5814 91.6021H77.8835V87.3C77.8835 86.6154 78.1554 85.9589 78.6395 85.4748C79.1236 84.9907 79.7801 84.7188 80.4647 84.7188Z",
    fill: "#202E5F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3529_34437",
    x: 22.5595,
    y: 44.9961,
    width: 115.714,
    height: 91.6226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.65508
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.7203
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.159429 0 0 0 0 0.0129687 0 0 0 0 0.345833 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3529_34437"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3529_34437",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPlaceholder);
export default __webpack_public_path__ + "static/media/calendarPlaceholder.35359cc78475147c006c84b94966c55b.svg";
export { ForwardRef as ReactComponent };